import { SortOption, SortOptions } from "~/types";

type Props = {
  value: SortOption;
  onChange: (value: SortOption) => void;
};

const sortLabels = {
  [SortOptions.NEWEST]: "新着順",
  [SortOptions.SALARY]: "月給が高い順",
  [SortOptions.HOLIDAY]: "年休が多い順",
} as const;

export const SortSelect: React.FC<Props> = ({ value, onChange }) => {
  return (
    <div className="relative text-sm leading-tight font-bold rounded border-[1.5px] border-default bg-gray-light">
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as SortOption)}
        className="relative bg-transparent z-10 py-2 pl-5 pr-10"
      >
        {Object.entries(sortLabels).map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <svg className="absolute right-4 top-[50%] translate-y-[-50%] block w-3 h-3 mx-auto fill-default">
        <use xlinkHref="/symbol-defs.svg#icon-chevron-bottom"></use>
      </svg>
    </div>
  );
};
